/**
 * Default app theme colors (hex). Must match backend and mobile.
 * Used to merge with API response so all keys are shown in Settings.
 */
export const DEFAULT_APP_COLORS: Record<string, string> = {
  lightPrimary: '#E85D2A',
  lightSecondary: '#F4A261',
  lightTertiary: '#E9C46A',
  lightBackground: '#FFF8F2',
  lightSurface: '#FFFFFF',
  lightText: '#2B1E16',
  lightTextSecondary: '#6F5A4D',
  lightTextTertiary: '#9C8A7E',
  lightBorder: '#E8DDD3',
  lightDivider: '#F0E5DA',
  darkPrimary: '#F07A3E',
  darkSecondary: '#FFB067',
  darkTertiary: '#E9C46A',
  darkBackground: '#121212',
  darkSurface: '#1C1C1C',
  darkSurfaceVariant: '#262626',
  darkText: '#FFFFFF',
  darkTextSecondary: '#CFCFCF',
  darkTextTertiary: '#8A8A8A',
  darkBorder: '#404040',
  darkDivider: '#333333',
  success: '#81C784',
  warning: '#FFB74D',
  error: '#EF5350',
  info: '#64B5F6',
  lightError: '#B00020',
  darkError: '#CF6679',
};

export const APP_COLOR_GROUPS: { label: string; keys: string[] }[] = [
  { label: 'Light theme', keys: ['lightPrimary', 'lightSecondary', 'lightTertiary', 'lightBackground', 'lightSurface', 'lightText', 'lightTextSecondary', 'lightTextTertiary', 'lightBorder', 'lightDivider', 'lightError'] },
  { label: 'Dark theme', keys: ['darkPrimary', 'darkSecondary', 'darkTertiary', 'darkBackground', 'darkSurface', 'darkSurfaceVariant', 'darkText', 'darkTextSecondary', 'darkTextTertiary', 'darkBorder', 'darkDivider', 'darkError'] },
  { label: 'Semantic', keys: ['success', 'warning', 'error', 'info'] },
];

function toLabel(key: string): string {
  return key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
}

export function getColorLabel(key: string): string {
  return toLabel(key);
}
